import { WidgetData } from '../model';

export const processDealWidgetLink = (link: WidgetData['data']['link']): Record<string, string> => {
  if (link && link.href) {
    return { link: link.href, 'link-text': 'View Deal' };
  }

  return {};
};
